import { render, staticRenderFns } from "./BarGroup.vue?vue&type=template&id=6a757adb&"
import script from "./BarGroup.vue?vue&type=script&lang=js&"
export * from "./BarGroup.vue?vue&type=script&lang=js&"
import style0 from "./BarGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports